export type EmailLogStatus = 'sent' | 'failed';

export interface EmailLogEntrySummaryApiResource {
  id: string;
  email_name: string;
  audience: string;
  recipient_address: string;
  subject: string;
  status: EmailLogStatus;
  failure_reason: string | null;
  carries_credential_link: boolean;
  is_resendable: boolean;
  resent_from_entry_id: string | null;
  created_at: string;
}

export interface EmailLogEntryDetailApiResource extends EmailLogEntrySummaryApiResource {
  language: string;
  sender_name: string;
  sender_address: string;
  reply_to_address: string | null;
  html_body: string | null;
  text_body: string | null;
}

export interface EmailLogEntrySummary {
  id: string;
  emailName: string;
  audience: string;
  recipientAddress: string;
  subject: string;
  status: EmailLogStatus;
  failureReason: string | null;
  carriesCredentialLink: boolean;
  isResendable: boolean;
  resentFromEntryId: string | null;
  createdAt: string;
}

export interface EmailLogEntryDetail extends EmailLogEntrySummary {
  language: string;
  senderName: string;
  senderAddress: string;
  replyToAddress: string | null;
  htmlBody: string | null;
  textBody: string | null;
}

export interface EmailLogQuery {
  page: number;
  pageSize: number;
  search: string;
  status: EmailLogStatus | null;
}

export function mapApiResourceToEmailLogEntrySummary(
  resource: EmailLogEntrySummaryApiResource
): EmailLogEntrySummary {
  return {
    id: resource.id,
    emailName: resource.email_name,
    audience: resource.audience,
    recipientAddress: resource.recipient_address,
    subject: resource.subject,
    status: resource.status,
    failureReason: resource.failure_reason,
    carriesCredentialLink: resource.carries_credential_link,
    isResendable: resource.is_resendable,
    resentFromEntryId: resource.resent_from_entry_id,
    createdAt: resource.created_at,
  };
}

export function mapApiResourceToEmailLogEntryDetail(
  resource: EmailLogEntryDetailApiResource
): EmailLogEntryDetail {
  return {
    ...mapApiResourceToEmailLogEntrySummary(resource),
    language: resource.language,
    senderName: resource.sender_name,
    senderAddress: resource.sender_address,
    replyToAddress: resource.reply_to_address,
    htmlBody: resource.html_body,
    textBody: resource.text_body,
  };
}
